'use strict';
import * as $j_app$002edata$002e$002dApp$002dDocument$002dLineage$002dRequest$0024$002dNew$002dVersion from "./app.data.-App-Document-Lineage-Request$-New-Version.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentLineageRequest$NewVersion$() {
}
export { $c_Lapp_data_AppDocumentLineageRequest$NewVersion$ as $c_Lapp_data_AppDocumentLineageRequest$NewVersion$ };
$p = $c_Lapp_data_AppDocumentLineageRequest$NewVersion$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentLineageRequest$NewVersion$;
/** @constructor */
function $h_Lapp_data_AppDocumentLineageRequest$NewVersion$() {
}
export { $h_Lapp_data_AppDocumentLineageRequest$NewVersion$ as $h_Lapp_data_AppDocumentLineageRequest$NewVersion$ };
$h_Lapp_data_AppDocumentLineageRequest$NewVersion$.prototype = $p;
$p.n = (function() {
  return "NewVersion";
});
$p.bKu = (function(x$0) {
  return new $j_app$002edata$002e$002dApp$002dDocument$002dLineage$002dRequest$0024$002dNew$002dVersion.$c_Lapp_data_AppDocumentLineageRequest$NewVersion(x$0.e(0));
});
$p.U = (function(p) {
  return this.bKu(p);
});
var $d_Lapp_data_AppDocumentLineageRequest$NewVersion$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentLineageRequest$NewVersion$, "app.data.AppDocumentLineageRequest$NewVersion$", ({
  Ck: 1,
  d: 1,
  e: 1
}));
export { $d_Lapp_data_AppDocumentLineageRequest$NewVersion$ as $d_Lapp_data_AppDocumentLineageRequest$NewVersion$ };
var $n_Lapp_data_AppDocumentLineageRequest$NewVersion$;
function $m_Lapp_data_AppDocumentLineageRequest$NewVersion$() {
  if ((!$n_Lapp_data_AppDocumentLineageRequest$NewVersion$)) {
    $n_Lapp_data_AppDocumentLineageRequest$NewVersion$ = new $c_Lapp_data_AppDocumentLineageRequest$NewVersion$();
  }
  return $n_Lapp_data_AppDocumentLineageRequest$NewVersion$;
}
export { $m_Lapp_data_AppDocumentLineageRequest$NewVersion$ as $m_Lapp_data_AppDocumentLineageRequest$NewVersion$ };
//# sourceMappingURL=app.data.-App-Document-Lineage-Request$-New-Version$.js.map
